import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { PageTitle } from "@/components/app/ui";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["business_name", "Business name", "input"], ["industry", "Industry", "input"], ["website", "Website", "input"], ["brand_colors", "Brand colours", "input"],
  ["description", "What does your business do?", "text"], ["audience", "Target audience", "text"], ["products", "Products / services", "text"],
  ["voice", "Brand voice (e.g., warm, expert, playful)", "text"], ["tone", "Tone guidance", "text"], ["key_messages", "Key messages", "text"],
  ["terms_to_avoid", "Terms to avoid", "text"], ["example_content", "Example content you like", "text"],
];

export default function Brand() {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/app/brand").then((r) => setF(r.data || {})); }, []);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, f[k] || ""]));
      await api.put("/app/brand", body);
      toast.success("Brand profile saved");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="brand-page">
      <PageTitle title="Brand Profile" copy="This guides every AI draft so your content stays on-brand. The more specific, the better." />
      <form onSubmit={save} className="card-box p-6 md:p-8 grid md:grid-cols-2 gap-5">
        {FIELDS.map(([k, l, t]) => (
          <div key={k} className={`space-y-2 ${t === "text" ? "md:col-span-1" : ""}`}>
            <Label>{l}</Label>
            {t === "input" ? <Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`brand-${k}-input`} />
              : <Textarea rows={3} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`brand-${k}-input`} />}
          </div>
        ))}
        <div className="md:col-span-2"><button disabled={busy} className="btn-brand" data-testid="brand-save-btn">{busy ? "Saving..." : "Save brand profile"}</button></div>
      </form>
    </div>
  );
}
